/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}